import React from "react";
import { useFormik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import DateTimeInputFormik from "../../../../components/UI/DateTimeInput/DateTimeInputFormik";
import SelectInput from "../../../../components/UI/SelectInput/SelectInput";
import SelectInputCachedFormik from "../../../../components/UI/SelectInput/SelectInputCachedFormik";
import TextInputFormik from "../../../../components/UI/TextInput/TextInputFormik";

const useFormBuscaAvancada = () => {
  const validationSchema = Yup.object().shape({
    numParteServico: Yup.string().default(),
    tipoParteServico: Yup.string().default(""),
    situacao: Yup.string().default(""),
    orgaoOrigem: Yup.string().default(""),
    orgaoDestino: Yup.string().default(""),
    dtInicio: Yup.string().default(""),
    dtFim: Yup.string().default(""),
    identificador: Yup.string().default(""),
    matriculaAuditor: Yup.string().default(""),
    nomeAuditor: Yup.string().default(""),
    razaoSocial: Yup.string().default(""),
  });

  const { parteServicoSearchParameters } = useSelector((state) => state.parteServicoSearch);

  const initialValues = { ...(parteServicoSearchParameters || {}) };

  validationSchema._nodes.forEach((key) => {
    initialValues[key] = "";
  });

  const formik = useFormik({
    initialValues: parteServicoSearchParameters,
    validationSchema,
  });

  const form = (
    <>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={6} md={3}>
          <Form.Label>Nº Parte Serviço</Form.Label>
          <TextInputFormik formik={formik} field="numParteServico" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={6} md={3}>
          <Form.Label>Tipo da Parte de Serviço</Form.Label>
          <br />
          <SelectInputCachedFormik formik={formik} field="tipoParteServico" tipoItem="tipo-parte-servico" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={6} md={3}>
          <Form.Label>Situação</Form.Label>
          <SelectInput
            formik={formik}
            field="situacao"
            options={[
              { key: "", value: "", text: "Selecione" },
              { value: "A", text: "Aberta" },
              { value: "S", text: "Salva" },
              { value: "V", text: "Vinculada ao Procedimento Fiscal" },
              { value: "G", text: "Gerada OS" },
              { value: "C", text: "Cancelada" },
              { value: "E", text: "Encerrada" },
            ]}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={6} md={3}>
          <Form.Label>Setor Origem</Form.Label>
          <br />
          <SelectInputCachedFormik formik={formik} field="orgaoOrigem" tipoItem="orgaos-os" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={6} md={3}>
          <Form.Label>Setor Destino</Form.Label>
          <br />
          <SelectInputCachedFormik formik={formik} field="orgaoDestino" tipoItem="orgaos-geral" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={6} md={3}>
          <Form.Label>Data Início da Inclusão</Form.Label>
          <DateTimeInputFormik formik={formik} field="dtInicio" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={6} md={3}>
          <Form.Label>Data Fim da Inclusão</Form.Label>
          <DateTimeInputFormik formik={formik} field="dtFim" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={6} md={3}>
          <Form.Label>IE/CNPJ/CPF</Form.Label>
          <TextInputFormik formik={formik} field="identificador" />
        </Form.Group>
        {/* <Form.Group as={Col} sm={6} md={3}>
        <Form.Label>Razão Social</Form.Label>
        <TextInputFormik formik={formik} field="RazaoSocial" />
      </Form.Group> */}
        <Form.Group className="mb-3" as={Col} sm={6} md={3}>
          <Form.Label>Matrícula Auditor</Form.Label>
          <TextInputFormik formik={formik} field="matriculaAuditor" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={6} md={3}>
          <Form.Label>Nome Auditor</Form.Label>
          <TextInputFormik formik={formik} field="nomeAuditor" />
        </Form.Group>
      </Row>
    </>
  );

  return {
    formik,
    form,
  };
};

export default useFormBuscaAvancada;
